import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { useAuth } from './providers/AuthProvider';

export interface RouterContext {
  auth?: ReturnType<typeof useAuth>;
}

export const router = createRouter({
  routeTree,
  context: { auth: undefined } as RouterContext,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function AppRouter() {
  const auth = useAuth();
  return <RouterProvider router={router} context={{ auth }} />;
}
